import { useMemo, useEffect } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { scmAuthApiRef } from '@backstage/integration-react';
import { create } from 'zustand';

const useGitHubLoginStatusStore = create((_set, getState) => ({
  statusMap: /* @__PURE__ */ new Map(),
  getStatus: (hash) => {
    return getState().statusMap.has(hash) ? getState().statusMap.get(hash) : false;
  }
}));
const useGithubLoggedIn = (hostname = "github.com", scope = ["repo"]) => {
  const { getStatus } = useGitHubLoginStatusStore();
  const scmAuth = useApi(scmAuthApiRef);
  const url = useMemo(() => `https://${hostname}`, [hostname]);
  const hash = useMemo(() => url + scope.toString(), [scope, url]);
  useEffect(() => {
    const doLogin = async () => {
      const credentials = await scmAuth.getCredentials({
        additionalScope: {
          customScopes: { github: scope }
        },
        url,
        optional: true
      });
      if (credentials?.token) {
        useGitHubLoginStatusStore.setState((prev) => ({
          ...prev,
          statusMap: new Map(prev.statusMap).set(hash, true)
        }));
      }
    };
    if (!getStatus(hash)) {
      doLogin();
    }
  }, [hash, hostname, scmAuth, scope, url, getStatus]);
  return {
    isLoggedIn: getStatus(hash),
    addLoginStatus: () => useGitHubLoginStatusStore.setState((prev) => ({
      ...prev,
      statusMap: new Map(prev.statusMap).set(hash, true)
    }))
  };
};

export { useGithubLoggedIn };
//# sourceMappingURL=useGithubLoggedIn.esm.js.map
